import { HeadwayServices } from 'shared/models/Services';
import baseApi from 'shared/utils/baseApi';
import { withClientId } from 'store/utils/withClientId';
import {
    ICreateEaf,
    IEafGroupedResponse, IEafItemsResponse,
    IEafReason,
    IEafRequest,
    IEmployeeActionForm,
    IGetMaxEntryDateResponse,
} from 'modules/employeeActionsForm/store/models';

const employeeActionFormsRoute = 'employee_action_forms';

export const eafApi = {
    async getGroupedEmployeeActionForms(
        request: IEafRequest,
    ): Promise<IEafGroupedResponse> {
        const { data } = await baseApi.post<IEafRequest, IEafGroupedResponse>(
            `/${HeadwayServices.ClientUsers}/${employeeActionFormsRoute}/grouped/search`,
            withClientId(request),
        );
        return data;
    },
    async getEafReasons(): Promise<IEafReason[]> {
        const { data } = await baseApi.get<{ reasons: IEafReason[] }>(
            `/${HeadwayServices.ClientUsers}/${employeeActionFormsRoute}/reasons`,
        );
        return data.reasons;
    },
    async createEmployeeActionForm(
        request: ICreateEaf,
    ): Promise<IEmployeeActionForm> {
        const { data } = await baseApi.post<ICreateEaf, IEmployeeActionForm>(
            `/${HeadwayServices.ClientUsers}/${employeeActionFormsRoute}`,
            request,
        );
        return data;
    },
    async getAssignmentMaxEntryDate(
        assignmentId: string,
    ): Promise<IGetMaxEntryDateResponse> {
        const { data } = await baseApi.get<IGetMaxEntryDateResponse>(
            `/sheets/coordinator/assignments/${assignmentId}/max_entry_date`,
        );
        return data;
    },
    async getEafItems(request: IEafRequest): Promise<IEafItemsResponse> {
        const url = `${HeadwayServices.ClientUsers}/${employeeActionFormsRoute}/search`;
        const response = await baseApi.post<IEafRequest, IEafItemsResponse>(
            url,
            request,
        );
        return response.data;
    },
};
